import {
  Box,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DrawerHeader from "../SpecialProject/DrawerHeader";
import { useSelector, useDispatch } from "react-redux";
import ListOfDropDown from "./ListOfDropDown";
import useThemeRender from "../../../../theme/useThemeRender";
import { darkTheme } from "../../../../theme/Theme";
import {
  setListOfFieldValueDescription,
  setListOfValueName,
  setListOfValueSelectedCountry,
  setListOfValueSelectedRole,
  setlistOfValueSelectedSector,
  setListOfValueStatus,
} from "../../../../slices/adminPageSlice";
import "../../../DocumentScreen//MobileScreenDocument.css";
import { getAPI, patchAPI, postAPI, putAPI } from "../../../../API/ApiService";
import { BASE_URL } from "../../../../constant/apiUrl";
import { setFavourite } from "../../../../slices/internalPageSlice";
import axios from "../../../../API/API";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../utils/Toast/toast";
import { SECTOR_COUNTRY_MAPPING, validatePageGroupName } from "./CONSTANT";
import { triggerRefetchNav } from "../../../../slices/navSlice";
import useDebounce from "../../../../hooks/useDebounce";
import { getAllNavigationLabels } from "../PageBuilder/createpages/dragUtils";

function ListOfValuesSideTray({ handleResetData }) {
  const {
    listOfValueSideTrayName,
    listOfValueName,
    listOfValueStatus,
    listOfFieldValueDescription,
    listOfValuesEndPoint,
    selectedListOfRowValue,
    listOfValueSelectedSector,
    listOfValueSelectedCountry,
    listOfValueSelectedRole,
  } = useSelector((store) => store.adminpage);
  const dispatch = useDispatch();

  const [sectorOption, setSectorOption] = useState([]);
  const [originalSectorOption, setOriginalSectorOption] = useState([]);
  const [countryOption, setCountryOption] = useState([]);
  const [originalCountryOption, setOriginalCountryOption] = useState([]);
  const [countryId, setCountryId] = useState([]);
  const [roleOption, setRoleOption] = useState([]);
  const [originalRoleOption, setOriginalRoleOption] = useState([]);
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState("");
  const isDarkTheme = useSelector((state) => state.theme);
  const isMobile = useMediaQuery("(max-width:600px)");
  const { navigations } = useSelector((store) => store.nav);
  
  // Debounce the name value for validation (only for PAGE_GROUP)
  const debouncedName = useDebounce(listOfValueName, 500);
  const handleChange = (e) => {
    let value = e.target.value;
    value = value.replace(/^\s+/, "");

    if (value.length > 0) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    dispatch(setListOfValueName(value));
  };
  const handleToggle = () => {
    dispatch(setListOfValueStatus(!listOfValueStatus));
  };
  const handleChangeDescription = (e) => {
    let value = e.target.value;
    value = value.replace(/^\s+/, "");

    if (value.length > 0) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    dispatch(setListOfFieldValueDescription(value));
  };
  const outlinedInputStyles = (isDarkTheme, darkTheme) => ({
    backgroundColor: isDarkTheme ? darkTheme.backgroundColorLayer1 : "white",
    height: "auto",
    "& fieldset": getFieldsetStyles(isDarkTheme),
    "&:hover fieldset": getHoverFieldsetStyles(isDarkTheme),
    "&.Mui-focused fieldset": getFocusedFieldsetStyles(isDarkTheme),
  });

  const getFieldsetStyles = (isDarkTheme) => ({
    borderColor: isDarkTheme ? "white" : " ",
    color: "white",
  });

  const getHoverFieldsetStyles = (isDarkTheme) => ({
    borderColor: isDarkTheme ? "white" : " ",
  });

  const getFocusedFieldsetStyles = (isDarkTheme) => ({
    borderColor: isDarkTheme ? "white" : " ",
  });
  const textColorLayer4 = useThemeRender("textColorLayer4");
  const textColorLayer2 = useThemeRender("textColorLayer2");
  const textColorLayer1 = useThemeRender("textColorLayer1");
  const { favourite } = useSelector((store) => store.internalPage);

  const handleAddCountrySector = async (newData) => {
    try {
      const response = await patchAPI(
        `${BASE_URL}/lookup/update-country-sector`,
        newData
      );
      if (response.status === 200) {
        handleResetData();
        dispatch(setFavourite(favourite + 1));
        showSuccessToast("You have successfully added a value");
      } else if (response?.status === 404) {
        showErrorToast("Already Exist");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleAddOtherLOV = async (newData) => {
    if (listOfValueName?.length === 0) {
      showErrorToast("Name field is required");
    } else if (listOfValueName?.length > 0) {
      try {
        const result = await postAPI(`${BASE_URL}/lookup/save-item`, newData);
        if (result?.status === 200) {
          handleResetData();
          dispatch(setFavourite(favourite + 1));

          showSuccessToast("You have successfully added a value");
        } else if (result?.status === 404) {
          showErrorToast("Already Exist");
        } else if (result?.status === 409) {
          const errors = result?.data;
          showErrorToast(errors?.message);
        }
      } catch (error) {
        console.log("Error submitting form:", error);
      }
    }
  };

  const handleSaveDisclaimer = async (data, type, url) => {
    try {
      const result = await type(`${BASE_URL}${url}`, data);
      if (result?.status === 200) {
        handleResetData();
        dispatch(setFavourite(favourite + 1));

        showSuccessToast(
          `You have successfully  ${
            type === postAPI ? "added" : "updated"
          } a value`
        );
      } else if (result?.status === 404) {
        showErrorToast("Already Exist");
      } else if (result?.status === 409) {
        const errors = result?.data;
        showErrorToast(errors?.message);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    }
  };

  const handleSavePageGroup = async (data, type, url) => {
    try {
      const result = await type(`${BASE_URL}${url}`, data);
      if (result?.status === 200) {
        handleResetData();
        dispatch(setFavourite(favourite + 1));
        dispatch(triggerRefetchNav(true));
        showSuccessToast(
          `You have successfully ${
            type === postAPI ? "added" : "updated"
          } a value`
        );
      } else if (result?.status === 404) {
        showErrorToast("Already Exist");
      } else if (result?.status === 302) {
        showErrorToast(result?.message);
      } else if (result?.status === 409) {
        const errors = result?.data;
        showErrorToast(errors?.message);
      }else if (result?.status === 400) {
        showErrorToast(result?.message);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    }
  };
  const addValue = () => {
    if (listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING) {
      const sectorName = originalSectorOption?.find(
        (item) => item?.name === listOfValueSelectedSector
      )?.id;
      const countryName = originalCountryOption?.find(
        (item) => item?.name === listOfValueSelectedCountry
      )?.id;
      if (sectorName && countryName) {
        const newData = {
          countryId: countryName,
          sectorId: sectorName,
          active: true,
        };
        handleAddCountrySector(newData);
      }
    } else if (listOfValuesEndPoint === "PAGE_GROUP") {
      if (!listOfValueName || listOfValueName.trim().length === 0) {
        showErrorToast("Name field is required");
        return;
      }
      if (validationError) {
        showErrorToast(validationError);
        return;
      }
      if (!listOfValueSelectedRole || listOfValueSelectedRole.trim() === "") {
        showErrorToast("Role field is required");
        return;
      }
      const roleId =
        originalRoleOption?.find(
          (item) => item?.name === listOfValueSelectedRole
        )?.id || 0;
      const newData = {
        tableName: "BUSINESS_UNIT",
        name: listOfValueName,
        description: listOfFieldValueDescription,
        active: true,
        roleId: roleId,
      };
      handleSavePageGroup(newData, postAPI, `/lookup/save-page-group`);
    } else if (listOfValuesEndPoint === "DISCLAIMER") {
      const newData = {
        tableName: "DISCLAIMER",
        name: listOfValueName,
        description: listOfFieldValueDescription,
        active: true,
      };
      handleSaveDisclaimer(newData, postAPI, `/lookup/save-disclaimer-item`);
    } else {
      const newData = {
        tableName: listOfValuesEndPoint,
        name: listOfValueName,
        description: listOfFieldValueDescription,
        active: true,
      };
      if (newData) {
        handleAddOtherLOV(newData);
      }
    }
  };

  const handleEditInsideCountrySector = async (newData) => {
    try {
      const response = await patchAPI(
        `${BASE_URL}/lookup/update-country-sector`,
        newData
      );
      if (response.status === 200) {
        handleResetData();
        dispatch(setFavourite(favourite + 1));
        showSuccessToast("You have successfully updated the value");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleEditCountrySector = async () => {
    const sectorId = originalSectorOption?.find(
      (item) => item?.name === listOfValueSelectedSector
    )?.id;
    const countryId = originalCountryOption?.find(
      (item) => item?.name === listOfValueSelectedCountry
    )?.id;
    if (sectorId && countryId) {
      const newData = {
        countryId: countryId,
        sectorId: sectorId,
        active: listOfValueStatus,
      };
      handleEditInsideCountrySector(newData);
    }
  };
  const handleEditOtherLOV = async (newData) => {
    if (listOfValueName?.length === 0) {
      showErrorToast("Name field is required");
    } else if (listOfValueName?.length > 0) {
      try {
        const result = await axios.patch(
          `${BASE_URL}/lookup/update-item/${selectedListOfRowValue?.id}`,
          newData
        );
        if (result?.status === 200) {
          showSuccessToast("You have successfully updated the value");
          dispatch(triggerRefetchNav(true));
          handleResetData();
          dispatch(setFavourite(favourite + 1));
        } else if (result?.status === 404) {
          showErrorToast("Already Exist");
        } else if (result?.status === 409) {
          const errors = result?.data;
          showErrorToast(errors?.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };
  const editValue = () => {
    if (listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING) {
      handleEditCountrySector();
    } else if (listOfValuesEndPoint === "PAGE_GROUP") {
      if (!listOfValueName || listOfValueName.trim().length === 0) {
        showErrorToast("Name field is required");
        return;
      }
      if (!listOfValueSelectedRole || listOfValueSelectedRole.trim() === "") {
        showErrorToast("Role field is required");
        return;
      }
      const roleId =
        originalRoleOption?.find(
          (item) => item?.name === listOfValueSelectedRole
        )?.id || 0;
      const newData = {
        tableName: "PAGE_GROUP",
        name: listOfValueName,
        description: listOfFieldValueDescription,
        active: listOfValueStatus,
        roleId: roleId,
      };
      handleSavePageGroup(
        newData,
        putAPI,
        `/lookup/update-page-group/${selectedListOfRowValue?.id}`
      );
    } else if (listOfValuesEndPoint === "DISCLAIMER") {
      const newData = {
        tableName: "DISCLAIMER",
        name: listOfValueName,
        description: listOfFieldValueDescription,
        active: listOfValueStatus,
      };
      handleSaveDisclaimer(
        newData,
        patchAPI,
        `/lookup/update-disclaimer-item/${selectedListOfRowValue?.id}`
      );
    } else {
      const newData = {
        tableName: listOfValuesEndPoint,
        name: listOfValueName,
        description: listOfFieldValueDescription,
        active: listOfValueStatus,
      };
      if (newData) {
        handleEditOtherLOV(newData);
      }
    }
  };

  const handleAddValue = () => {
    if (listOfValueSideTrayName === "Add value") {
      addValue();
    } else if (listOfValueSideTrayName === "Edit value") {
      editValue();
    }
  };

  useEffect(() => {
    dispatch(setListOfValueSelectedRole(""));
    // Reset validation error when switching between add/edit modes
    setValidationError("");
    if (selectedListOfRowValue !== "") {
      if (listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING) {
        dispatch(
          setlistOfValueSelectedSector(selectedListOfRowValue?.sector?.name)
        );
        dispatch(setListOfValueSelectedCountry(selectedListOfRowValue?.name));
        setCountryId(selectedListOfRowValue?.id);
      } else {
        dispatch(setListOfValueName(selectedListOfRowValue.name));
        dispatch(
          setListOfFieldValueDescription(selectedListOfRowValue.description)
        );
        dispatch(setListOfValueStatus(selectedListOfRowValue?.active));

        // Set role for PAGE_GROUP when editing - will be set after options load based on roleId
        if (
          listOfValuesEndPoint === "PAGE_GROUP" &&
          selectedListOfRowValue?.roleId
        ) {
          // Role will be set after options are loaded in the useEffect below
        }
      }
    }
  }, [selectedListOfRowValue, listOfValuesEndPoint, dispatch]);

  useEffect(() => {
    const fetchSectorData = async () => {
      try {
        const response = await getAPI(
          `${BASE_URL}/lookup/all?lookUpType=SECTOR`
        );
        if (response?.status === 200) {
          const namesArray = response?.data.map((item) => item.name);
          setSectorOption(namesArray);
          setOriginalSectorOption(response?.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    const fetchCountryData = async () => {
      try {
        const response = await getAPI(
          `${BASE_URL}/lookup/all?lookUpType=COUNTRY`
        );
        if (response?.status == 200) {
          const namesArray = response?.data.map((item) => item.name);
          setCountryOption(namesArray);
          setOriginalCountryOption(response?.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchSectorData();
    fetchCountryData();
  }, []);

  useEffect(() => {
    const fetchRolesData = async () => {
      if (listOfValuesEndPoint === "PAGE_GROUP") {
        try {
          const response = await getAPI(`${BASE_URL}/admin/roles/find-all`);
          if (response?.status === 200) {
            const rolesData = response?.data?.response || [];
            const namesArray = rolesData.map((item) => item.name);
            setRoleOption(namesArray || []);
            setOriginalRoleOption(rolesData);
          }
        } catch (err) {
          console.log(err.message);
          setRoleOption([]);
          setOriginalRoleOption([]);
        }
      }
    };
    fetchRolesData();
  }, [listOfValuesEndPoint]);

  // Set role value based on roleId after options are loaded or when selectedListOfRowValue changes
  useEffect(() => {
    if (
      listOfValuesEndPoint === "PAGE_GROUP" &&
      originalRoleOption.length > 0 &&
      selectedListOfRowValue &&
      selectedListOfRowValue !== "" &&
      selectedListOfRowValue?.roleId
    ) {
      const role = originalRoleOption.find(
        (item) => item.id === selectedListOfRowValue.roleId
      );
      if (role && role.name) {
        dispatch(setListOfValueSelectedRole(role.name));
      }
    }
  }, [
    originalRoleOption,
    selectedListOfRowValue,
    listOfValuesEndPoint,
    dispatch,
  ]);

  // Reset validation error when endpoint changes
  useEffect(() => {
    setValidationError("");
    setIsValidating(false);
  }, [listOfValuesEndPoint]);

  // Validate name for PAGE_GROUP with debouncing (using Redux navigations, no API call)
  useEffect(() => {
    // Only validate for PAGE_GROUP and when adding a new value (not editing)
    if (
      listOfValuesEndPoint === "PAGE_GROUP" &&
      debouncedName &&
      debouncedName.trim().length > 0 &&
      navigations &&
      Array.isArray(navigations)
    ) {
      // Skip validation if it's the same as the selected row value (editing scenario)
      if (
        selectedListOfRowValue &&
        selectedListOfRowValue.name === debouncedName
      ) {
        setValidationError("");
        return;
      }

      // Get navigationId to exclude when editing
      // Find navigationId by matching the original name in navigations
      let excludeId = null;
      if (selectedListOfRowValue && selectedListOfRowValue.name) {
        const allLabels = getAllNavigationLabels(navigations);
        const matchingNav = allLabels.find(
          (item) => item.label?.toLowerCase().trim() === selectedListOfRowValue.name?.toLowerCase().trim() &&
                    item.type === "INTERNAL_GROUP"
        );
        if (matchingNav) {
          excludeId = matchingNav.navigationId;
        }
      }

      // Use Redux-based validation (no API call)
      setIsValidating(false); // No async operation needed
      validatePageGroupName(debouncedName, navigations, excludeId, setValidationError);
    } else {
      // Reset validation error when not in PAGE_GROUP or when field is empty
      if (listOfValuesEndPoint !== "PAGE_GROUP" || !debouncedName || debouncedName.trim().length === 0) {
        setValidationError("");
        setIsValidating(false);
      }
    }
  }, [
    debouncedName,
    listOfValuesEndPoint,
    listOfValueSideTrayName,
    selectedListOfRowValue,
    navigations,
  ]);

  return (
    <>
      <Box
        sx={{
          mt: "18px",
          height: "90%",
          minWidth: isMobile ? "100%" : "375px",
          width: "40%",
        }}
      >
        <DrawerHeader
          header={listOfValueSideTrayName}
          handleResetData={handleResetData}
        />
        {listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING ? (
          <>
            <Box sx={{ padding: "10px" }}>
              <ListOfDropDown
                options={sectorOption}
                label={"sector"}
                value={"ListofValueSector"}
              />
            </Box>
            <Box sx={{ padding: "10px" }}>
              <ListOfDropDown
                options={countryOption}
                label={"Country"}
                value={"ListofValueCountry"}
              />
            </Box>
          </>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* Name */}
            <Typography
              sx={{ color: textColorLayer2 }}
              className="listOfValue-custom-text-field-label"
              variant="h5"
            >
              Name
            </Typography>
            <TextField
              placeholder="Type here"
              size="small"
              fullWidth
              className="listOfValue-custom-text-input"
              error={!!validationError}
              helperText={validationError || (isValidating && "Validating...")}
              sx={{
                "& .MuiInputBase-input::placeholder": {
                  color: textColorLayer4,
                },
                "& .MuiOutlinedInput-root": outlinedInputStyles(
                  isDarkTheme,
                  darkTheme
                ),
                "& .MuiInputBase-input": {
                  color: textColorLayer1,
                },
                "& .MuiFormHelperText-root": {
                  color: validationError ? "#d32f2f" : textColorLayer4,
                },
              }}
              value={listOfValueName}
              onChange={handleChange}
            />

            {/* Description */}
            <Typography
              sx={{ color: textColorLayer2 }}
              className="listOfValue-custom-text-field-label"
              variant="h5"
            >
              Description
            </Typography>
            <TextField
              placeholder="Type here"
              size="small"
              fullWidth
              multiline
              minRows={1} // Minimum visible rows
              maxRows={10} // Optional: prevent it from growing too large
              sx={{
                "& .MuiInputBase-input::placeholder": {
                  color: textColorLayer4,
                },
                "& .MuiOutlinedInput-root": outlinedInputStyles(
                  isDarkTheme,
                  darkTheme
                ),
                "& .MuiInputBase-input": {
                  color: textColorLayer1,
                },
              }}
              className="listOfValue-custom-text-input"
              value={listOfFieldValueDescription}
              onChange={handleChangeDescription}
            />

            {/* Role Dropdown - Only shown for Page Group */}
            {listOfValuesEndPoint === "PAGE_GROUP" && (
              <Box sx={{ padding: "10px" }}>
                <ListOfDropDown
                  options={roleOption}
                  label={"Role"}
                  value={"ListofValueRole"}
                />
              </Box>
            )}
          </Box>
        )}
        {listOfValueSideTrayName === "Edit value" &&
          listOfValuesEndPoint !== SECTOR_COUNTRY_MAPPING && (
            <Box
              sx={{
                display: "flex",
                height: "32px",
                alignItems: "center",
                gap: "var(--Spacing-spacing-03, 8px)",
                mt: "5px",
                mb: "5px",
                paddingX: "10px",
              }}
            >
              <Box
                sx={{
                  color: textColorLayer4,
                  fontFeatureSettings: "'liga' off, 'clig' off",
                  fontFamily: "var(--Typography-Font-Family-Body, Inter)",
                  fontSize: "var(--Font-Size-XSmall, 12px)",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "var(--Line-Height-XSmall, 18px)",
                }}
              >
                Active value
              </Box>
              <Switch checked={listOfValueStatus} onChange={handleToggle} />
            </Box>
          )}
      </Box>
      <Box className="ButtonBox">
        <Box
          sx={{
            border:
              "var(--Border-border-1, 1px) solid var(--Tokens-Button-Outlined, #005CBC)",
          }}
          className="ButtonStyle"
          onClick={handleResetData}
        >
          <Typography
            sx={{
              color: "#005CBC",
              fontWeight: 700,
            }}
            className="textStyle"
          >
            Cancel
          </Typography>
        </Box>
        <Box
          sx={{
            background: "var(--Tokens-Button-Primary, #005CBC)",
            opacity: validationError && listOfValueSideTrayName === "Add value" ? 0.5 : 1,
            cursor: validationError && listOfValueSideTrayName === "Add value" ? "not-allowed" : "pointer",
          }}
          className="ButtonStyle"
          onClick={
            validationError && listOfValueSideTrayName === "Add value"
              ? undefined
              : handleAddValue
          }
        >
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 700,
              p: "5px 10px",
            }}
            className="textStyle"
          >
            {listOfValueSideTrayName === "Edit value"
              ? "Save value"
              : "Add value"}
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default ListOfValuesSideTray;
